<template>
  <div>
    <section class="tile">
        <div class="tile-header dvd dvd-btm">
            <h1>Liste des utilisateurs</h1>
        </div>
        <div class="tile-body">
            <list :columns="columns" :dataSet="dataSet"></list>
        </div>
    </section>
  </div>
</template>

<script>

import users from '../../requests/users.js'
import List from '../others/list.vue'

export default {
  name: 'users_list',
  components: {
    List
  },
  data () {
    return{
      dataSet:[],
      columns:[]
    }
  },
  mounted:function(){
    this.getData();
  },
  methods:{
    getData(){
      var parent = this;
      users.getAll(this,function(users,error){
        if (!error) {
            parent.dataSet = [];
            for(var a=0;a<users.length;a++){
                var tr = [];
                tr.push(users[a].email);
                tr.push(users[a].username);
                tr.push(users[a].firstname);
                tr.push(users[a].lastname);
                tr.push(users[a].role == 'dev' ? '<span class="label label-sm label-success">Développeur</span>' : users[a].role);
                tr.push(
                    '<a data-route-name="users_edit" data-id="'+users[a].id+'" class="btn btn-default btn-circle text-right ml-5 btn_table"><i class="icon-note"></i></a>'
                )
  
                parent.dataSet.push(tr);
            }

            $(document).off('click','.btn_table');
            $(document).on('click', '.btn_table', function () {
                parent.$router.push({name:this.getAttribute("data-route-name"),params:{id:this.getAttribute("data-id")}})
            });

            parent.columns = [];
            parent.columns.push({title:"Email"});
            parent.columns.push({title:"Username"});
            parent.columns.push({title:"Prénom"});
            parent.columns.push({title:"Nom"});
            parent.columns.push({title:"Role"});
            parent.columns.push({title:"Actions","searchable": false,"orderable": false,class:"text-right"});
        } else {
            toastr.error("ERREUR dans la récupération des utilisateurs.");
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// list.vue?0ce74df1